module.exports = __webpack_public_path__ + "img/oxbridgeaq.863d7f5c.png";